import { useDispatch } from 'react-redux'

import { homeGetStarted } from 'actions/home'
import { useGetCtaProps } from 'routes/Home/Cta'

export const useHandleSignupCTAClick = () => {
  const dispatch = useDispatch()
  const { ctaUri } = useGetCtaProps()

  const handleSignupCTAClick = () => {
    dispatch(homeGetStarted(ctaUri))
  }

  return handleSignupCTAClick
}
